import React from 'react';
import { SectionHeading } from '../components/ui/SectionHeading';
export function TermsPage() {
  return <div className="pt-32 pb-20 bg-white" data-id="element-496">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-497">
        <SectionHeading title="Terms of Service" className="mb-12" data-id="element-498" />

        <div className="prose prose-slate lg:prose-lg" data-id="element-499">
          <p className="lead" data-id="element-500">Last updated: May 15, 2024</p>

          <h3 data-id="element-501">1. Agreement to Terms</h3>
          <p data-id="element-502">
            These Terms of Service constitute a legally binding agreement made
            between you, whether personally or on behalf of an entity ("you")
            and NexusFlow ("we," "us" or "our"), concerning your access to and
            use of the NexusFlow website as well as any other media form, media
            channel, mobile website or mobile application related, linked, or
            otherwise connected thereto (collectively, the "Site").
          </p>

          <h3 data-id="element-503">2. Intellectual Property Rights</h3>
          <p data-id="element-504">
            Unless otherwise indicated, the Site is our proprietary property and
            all source code, databases, functionality, software, website
            designs, audio, video, text, photographs, and graphics on the Site
            (collectively, the "Content") and the trademarks, service marks, and
            logos contained therein (the "Marks") are owned or controlled by us
            or licensed to us, and are protected by copyright and trademark
            laws.
          </p>

          <h3 data-id="element-505">3. User Representations</h3>
          <p data-id="element-506">By using the Site, you represent and warrant that:</p>
          <ul data-id="element-507">
            <li data-id="element-508">
              All registration information you submit will be true, accurate,
              current, and complete.
            </li>
            <li data-id="element-509">
              You will maintain the accuracy of such information and promptly
              update such registration information as necessary.
            </li>
            <li data-id="element-510">
              You have the legal capacity and you agree to comply with these
              Terms of Service.
            </li>
            <li data-id="element-511">
              You are not a minor in the jurisdiction in which you reside.
            </li>
          </ul>

          <h3 data-id="element-512">4. Prohibited Activities</h3>
          <p data-id="element-513">
            You may not access or use the Site for any purpose other than that
            for which we make the Site available. The Site may not be used in
            connection with any commercial endeavors except those that are
            specifically endorsed or approved by us.
          </p>

          <h3 data-id="element-514">5. Contact Us</h3>
          <p data-id="element-515">
            In order to resolve a complaint regarding the Site or to receive
            further information regarding use of the Site, please contact us at:
            <br data-id="element-516" />
            <a href="mailto:legal@nexusflow.com" className="text-indigo-600 hover:underline" data-id="element-517">
              legal@nexusflow.com
            </a>
          </p>
        </div>
      </div>
    </div>;
}